module.exports = __webpack_public_path__ + "img/kjicon4.59edda3e.svg";